export default __webpack_public_path__ + "static/media/eth-token-symbol.c5bff44f.svg";